import script from "./paySet.vue?vue&type=script&setup=true&lang=js"
export * from "./paySet.vue?vue&type=script&setup=true&lang=js"

import "./paySet.vue?vue&type=style&index=0&id=375edb06&scoped=true&lang=less"

import exportComponent from "G:\\workBench\\my_server_project\\eventvue\\myEvents\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-375edb06"]])

export default __exports__